<div class="auth-card">
	<div class="image">
		<img
			ngSrc="/static/images/auth/auth-banner.png"
			fill
			priority="1"
			alt=""
		/>
	</div>
	<form
		autocomplete="off"
		class="auth-form"
		[formGroup]="credentials"
	>
		<img
			ngSrc="/static/images/auth/logo-dark.svg"
			height="36"
			width="133"
		/>
		<lib-button
			[type]="ButtonType.Outlined"
			[leftSvgIcon]="github"
			label="Login with GitHub"
		></lib-button>
		<lib-divider>or</lib-divider>
		<lib-input-text
			autocomplete="false"
			formControlName="email"
			placeholder="Email"
			label="Email"
			defaultValue=""
		/>
		<lib-input-text
			autocomplete="false"
			type="password"
			formControlName="password"
			placeholder="Password"
			type="password"
			label="Password"
			defaultValue=""
			(focus)="showPasswordStrength = true"
			(blur)="showPasswordStrength = false"
		/>
		<lib-password-strength
			[hidden]="!showPasswordStrength"
			[validators]="passwordValidators"
			[validationMessages]="validationMessages"
			[password]="credentials.value.password || 'z'"
			[regexRules]="regexRules"
		></lib-password-strength>
		<lib-button
			[loading]="true"
			(click)="submit()"
			label="Create account"
		></lib-button>

		<lib-button
			[type]="ButtonType.Secondary"
			routerLink="/login"
			label="Sign In"
		>
		</lib-button>
	</form>
</div>
